// extracted by mini-css-extract-plugin
module.exports = {"content":"title6Tout_content__suFC6","titles":"title6Tout_titles__J_IwQ","bodies":"title6Tout_bodies__erpB0","buttonGroup":"title6Tout_buttonGroup__o4_OK"};